var translation = {
	"Your profile": "내 프로필",
	"View profile": "프로필 보기",
	"Personal information": "개인 정보",
	"Community information": "커뮤니티 정보",
	"Workplace information": "직장 정보",
	"Email Preferences Center": "이메일 기본 설정 센터",
	"Builder ID privacy & data": "Builder ID 개인정보 보호 및 데이터",
	"About profiles": "프로필 정보",
	"Welcome back": "재방문을 환영합니다",
	"Personal email address": "개인 이메일 주소",
	Email: "이메일",
	Edit: "편집",
	Save: "저장",
	"All fields marked with an asterisk (*) are required.": "별표(*)로 표시된 모든 필드는 필수 필드입니다.",
	"Choose an option": "옵션을 선택하세요",
	"Visible to others": "다른 사람에게 공개",
	"Fields in this section will be visible to others.": "이 섹션의 필드는 다른 사람이 볼 수 있습니다.",
	"Display name": "표시 이름",
	Alias: "별칭",
	Bio: "바이오",
	"Github profile": "Github 프로필",
	"Youtube profile": "Youtube 프로필",
	"Facebook profile": "Facebook 프로필",
	"re:Post profile": "re:Post 프로필",
	"Dev:to profile": "Dev:to 프로필",
	"Link to blog": "블로그 링크",
	"LinkedIn profile": "LinkedIn 프로필",
	"X profile": "X 프로필",
	Social: "소셜",
	Username: "사용자 이름",
	"Add social link": "소셜 링크 추가",
	"Interest & background information": "관심사 및 배경 정보",
	"Manage your interests and other information that are used in recommending content. ": "콘텐츠를 추천하는 데 사용되는 관심사 및 기타 정보를 관리합니다. ",
	Interests: "관심사",
	"Search interests": "관심사 검색",
	Country: "국가",
	"State/province": "시/도",
	"Role type": "역할 유형",
	"Industry focus": "중점 산업 분야",
	"Level of AWS usage": "AWS 사용 수준",
	"Use case focus": "중점 사용 사례",
	"Manage your work information to accurately represent your organization.": "조직을 정확하게 표현할 수 있도록 업무 정보를 관리합니다.",
	"Business email address": "회사 이메일 주소",
	"Business phone number": "업무용 전화번호",
	"Company website": "회사 웹사이트",
	"Job title": "직책",
	"Company name": "회사 이름",
	"Company type": "회사 유형",
	"Company size": "회사 규모",
	"Project timeline": "프로젝트 타임라인",
	"Powered by Profile": "프로필 기반",
	About: "소개",
	"Make your profile": "프로필 만들기",
	Profile: "프로필",
	"Get started": "시작하기",
	"Manage your information and preferences that are used to improve select AWS experiences.": "일부 AWS 경험을 개선하는 데 사용되는 정보 및 기본 설정을 관리합니다. ",
	"Sign in/Get started": "로그인/시작하기",
	"Key things to know": "알아야 할 주요 내용",
	"Access experience": "액세스 경험",
	"Control your data": "데이터 제어",
	"Read about privacy": "개인정보 처리방침 알아보기",
	"Email preference center": "이메일 기본 설정 센터",
	"This field is required.": "이 필드는 필수입니다.",
	"Your profile helps improve your interactions with select AWS experiences.": "프로필을 통해 일부 AWS 경험과의 상호 작용을 개선할 수 있습니다.",
	City: "구/군/시",
	"Page topics": "페이지 주제",
	"User information": "사용자 정보",
	"Full name": "전체 이름",
	Discard: "삭제",
	Link: "링크",
	"Short bio": "짧은 바이오",
	"Add interest": "관심사 추가",
	"Unsaved changes": "저장되지 않은 변경 사항",
	"Please make a change before saving.": "저장하기 전에 변경하세요.",
	"Changes could not be saved.": "변경 사항을 저장할 수 없습니다.",
	"Your information has been saved.": "정보가 저장되었습니다.",
	"Your new Profile Picture": "새 프로필 사진",
	"Profile Picture": "프로필 사진",
	"Your profile picture makes you easily recognizable and shows when you're signed in.": "프로필 사진이 있으면 다른 사용자가 나를 쉽게 알아볼 수 있으며 로그인했을 때 프로필 사진이 표시됩니다.",
	Cancel: "취소",
	"Save profile picture": "프로필 사진 저장",
	"Change profile picture": "프로필 사진 변경",
	"Remove profile picture": "프로필 사진 삭제",
	Zoom: "확대/축소",
	"20MB maximum file size, only .jpg, .jpeg, .png, .webp file types supported": "최대 파일 크기는 20MB이고 .jpg, .jpeg, .png, .webp 파일 유형만 지원됨",
	"Drag and drop": "드래그 앤 드롭",
	"or browse files": "또는 파일 찾아보기",
	"or Browse files (browse files is link to open files)": "또는 파일 찾아보기(파일 찾아보기는 파일을 여는 링크임)",
	"There was an error processing your profile picture, please try again.": "프로필 사진을 처리하는 중 오류가 발생했습니다. 다시 시도해 주세요.",
	"Your profile picture has been updated.": "프로필 사진이 업데이트되었습니다.",
	"File size above 20MB.": "파일 크기가 20MB를 초과합니다.",
	"Invalid file type.": "잘못된 파일 유형입니다.",
	"An error occurred.": "오류가 발생했습니다.",
	"Click or drag file to this area (backup from community in case we change our mind on drag and drop text)": "파일을 클릭하거나 이 영역으로 드래그(드래그 앤 드롭 텍스트에 대한 방침이 바뀔 경우에 대비하여 커뮤니티에서 백업)",
	"I agree to the terms of the <a href=#1 target=\"_blank\" rel=\"noopener noreferrer\">AWS Customer Agreement</a> and the <a href=#2 target=\"_blank\" rel=\"noopener noreferrer\">Statement on the Collection and Use of Personal Information.</a>": "<a href=#1 target=\"_blank\" rel=\"noopener noreferrer\">AWS 이용계약</a> 및 <a href=#2 target=\"_blank\" rel=\"noopener noreferrer\">개인정보의 수집 및 이용에 대한 사항</a> 에 동의합니다.",
	"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf": "https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_KR.pdf",
	"Sign into your profile": "프로필에 로그인",
	"Sign in": "로그인하기",
	"First name": "이름",
	"Last name": "성",
	"Phone number": "전화번호",
	"Postal code": "우편 번호",
	"Business address": "비즈니스 주소",
	Select: "선택",
	"Enter text": "텍스트 입력",
	"Business Interests": "사업 관심사",
	"Personal Interests": "개인 관심사들",
	"Manage your email through <a class=\"link\" href=\"https://profile.aws.amazon.com/#/profile/details\" rel=\"noopener noreferrer\" target=\"_blank\">AWS Builder ID</a>": "<a class=\"link\" href=\"https://profile.aws.amazon.com/#/profile/details\" rel=\"noopener noreferrer\" target=\"_blank\">AWS Builder ID</a>를 통한 이메일 관리",
	"Manage information that other members in the community will see when you create content on <a class=\"link\" href=\"https://builder.aws.com\">Builder Center</a> or leave comments on <a class=\"link\" href=\"https://aws.amazon.com/blogs\">AWS Blogs</a>.": "<a class=\"link\" href=\"https://builder.aws.com\" target=\"_blank\" rel=\"noopener noreferrer\">Builder Center</a>에서 콘텐츠를 생성하고 <a class=\"link\" href=\"https://aws.amazon.com/blogs\" target=\"_blank\" rel=\"noopener noreferrer\">AWS Blog</a>에 댓글을 남길 때 커뮤니티의 다른 구성원에게 공개할 정보를 관리할 수 있습니다.",
	"Profile is used to improve select AWS experiences. <a href=#>Learn more</a>": "프로필은 일부 AWS 경험을 개선하는 데 사용됩니다. <a href=#>자세히 알아보기</a>",
	"Profile is currently connected to select experiences, which includes <a href=#1>Builder Center</a>, <a href=#2>AWS Blogs</a>, <a href=#3>AWS Startups</a>, select forms and surveys on AWS Pulse, and select online webinar registrations and content downloads. ": "프로필은 현재 <a href=#1 rel=\"noopener noreferrer\" target=\"_blank\">Builder Center</a>, <a href=#2 rel=\"noopener noreferrer\" target=\"_blank\">AWS Blog</a>, <a href=#3 rel=\"noopener noreferrer\" target=\"_blank\">AWS Startups</a>, AWS Pulse의 일부 양식 및 설문 조사, 일부 온라인 웨비나 등록 및 콘텐츠 다운로드 등 일부 경험에 연결되어 있습니다. ",
	"You can access and update your profile at anytime by going to <a href=#>Profile</a>.": "<a href=#>프로필</a>로 이동하여 언제든지 프로필에 액세스하고 업데이트할 수 있습니다.",
	"There are unsaved changes in the <a href=\"#\">{{profile}}</a> section. Would you like to save or discard?": "<a href=\"#\">{{profile}}</a> 섹션에 저장되지 않은 변경 사항이 있습니다. 저장하시겠습니까, 아니면 삭제하시겠습니까?",
	or: "또는",
	"browse files": "파일 찾아보기",
	"Claim your alias": "별칭 등록하기",
	"Your alias will be visible to all members of our community and is how other builders connect with you. Your alias cannot be changed after claiming.": "귀하의 별칭은 커뮤니티의 모든 구성원에게 표시되며 다른 개발자들이 귀하와 연결하는 방법입니다. 별칭은 등록 후 변경할 수 없습니다.",
	"Enter your alias": "별칭을 입력하세요",
	"Are you sure you want to claim? This action cannot be undone.": "정말로 등록하시겠습니까? 이 작업은 취소할 수 없습니다.",
	Claim: "등록하기",
	Claimed: "등록됨",
	"Checking availability": "사용 가능 여부 확인 중",
	Claiming: "등록 중",
	"Alias must be 3 to 19 characters.": "별칭은 3~19자여야 합니다.",
	"Alias must only contain alphanumeric characters (a-z, 0-9).": "별칭은 영숫자(a-z, 0-9)만 포함해야 합니다.",
	"Alias is already claimed.": "이 별칭은 이미 등록되었습니다.",
	"Unable to save your content.": "내용을 저장할 수 없습니다.",
	"Your alias will be visible to all members of our community and is how other builders connect with you. Your alias <b>cannot</b> be changed after claiming.": "귀하의 별칭은 커뮤니티의 모든 구성원에게 표시되며 다른 개발자들이 귀하와 연결하는 방법입니다. 별칭은 등록 후 <b>변경할 수 없습니다</b>.",
	"Your alias must be 3 to 19 alphanumeric characters (contains only a-z, 0-9) and not violate our <a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">Terms and Services</a>.": "별칭은 3~19자의 영숫자(a-z, 0-9만 포함)여야 하며 <a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">이용 약관</a>을 위반하지 않아야 합니다.",
	"Please ensure all fields adhere to our <a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">Code of Conduct</a> before trying again.": "다시 시도하기 전에 모든 필드가 <a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">행동 강령</a>을 준수하는지 확인하세요.",
	"If you're still having trouble, feel free to <a class=\"link\" href=\"https://pulse.aws/application/V5ZJLDOL?p=0\" rel=\"noopener noreferrer\" target=\"_blank\">contact us</a> for assistance.": "여전히 문제가 있다면 <a class=\"link\" href=\"https://pulse.aws/application/V5ZJLDOL?p=0\" rel=\"noopener noreferrer\" target=\"_blank\">문의하기</a>를 통해 도움을 받으실 수 있습니다.",
	"Having trouble saving content?": "콘텐츠 저장에 문제가 있습니까?",
	"Checking alias availability was not successful. Please try again.": "별칭 가용성 확인에 실패했습니다. 다시 시도해 주세요.",
	"This field contains invalid characters.": "이 필드에 유효하지 않은 문자가 포함되어 있습니다.",
	"Select up to 10 interests": "관심사를 최대 10개까지 선택",
	"Must be 7-15 digits.": "7-15자리여야 합니다.",
	"Invalid postal code. Postal codes may include only letters (A-Z and a-z), numbers (0-9), dashes (-), and spaces.": "우편번호가 유효하지 않습니다. 우편번호는 문자(A-Z 및 a-z), 숫자(0-9), 대시(-) 및 공백만 포함할 수 있습니다.",
	"This name is not valid. Names can include only letters (A-Z and a-z), numbers (0-9), dashes (-), and periods (.).": "이 이름이 유효하지 않습니다. 이름은 문자(A-Z 및 a-z), 숫자(0-9), 대시(-) 및 마침표(.)만 포함할 수 있습니다.",
	"Invalid email address": "유효하지 않은 이메일 주소",
	"Must be 64 characters or less": "64자 이하여야 합니다",
	"Must be 100 characters or less": "100자 이하여야 합니다",
	"2 more interests remaining.": "2개 더 선택할 수 있습니다.",
	"1 more interest remaining.": "1개 더 선택할 수 있습니다.",
	"You've reached the maximum number of interests. To add others, please remove an existing item.": "관심사 최대 개수에 도달했습니다. 다른 항목을 추가하려면 기존 항목을 제거하세요.",
	"Work city": "회사 소재 도시",
	"Work postal code": "회사 우편 번호",
	"I agree to the terms of the <a class=\"link\" href=\"https://aws.amazon.com/agreement/\" target=\"_blank\" rel=\"noopener noreferrer\">AWS Customer Agreement</a> and the <a class=\"link\" href=\"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">Statement on the Collection and Use of Personal Information.</a>": "<a class=\"link\" href=\"https://aws.amazon.com/agreement/\" target=\"_blank\" rel=\"noopener noreferrer\">AWS 이용계약</a> 및 <a class=\"link\" href=\"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">개인정보의 수집 및 이용에 대한 사항</a> 에 동의합니다.",
	Emails: "이메일",
	"AWS Builder ID": "AWS 빌더 ID",
	"Additional emails let you use different email addresses for select AWS experiences, while keeping your AWS Builder ID email for sign-in.": "추가 이메일을 사용하면 AWS 빌더 ID 이메일로 로그인하면서 선택한 AWS 경험에 대해 다른 이메일 주소를 사용할 수 있습니다.",
	Personal: "개인",
	Business: "비즈니스",
	None: "없음",
	"Verify email": "이메일 확인",
	Unverified: "미확인",
	"Add email": "이메일 추가",
	"Add an email address": "이메일 주소 추가",
	"Enter verification code": "인증 코드 입력",
	"A 6-digit verification code has been sent to <span class=\"font-bold\">{{email}}</span>. Please enter it below to confirm your email address.": "6자리 인증 코드가 <span class=\"font-bold\">{{email}}</span>로 전송되었습니다. 이메일 주소를 확인하려면 아래에 입력하세요.",
	"Verification limit reached": "인증 제한에 도달함",
	"You've made the maximum number of requests allowed today. Please try again after 24 hours.": "오늘 허용된 최대 요청 횟수에 도달했습니다. 24시간 후에 다시 시도해 주세요.",
	Okay: "확인",
	"Delete Email": "이메일 삭제",
	"Are you sure you want to remove your email?": "이메일을 삭제하시겠습니까?",
	"Please type <span class=\"font-bold\">{{email}}</span> to continue with removal:": "삭제를 계속하려면 <span class=\"font-bold\">{{email}}</span>을 입력하세요:",
	"Didn't receive a code?": "코드를 받지 못하셨나요?",
	"Request a new code.": "새 코드 요청하기.",
	"Additional emails": "추가 이메일",
	Type: "유형",
	Skip: "건너뛰기",
	Submit: "제출",
	"Emails are different": "이메일이 다릅니다",
	"Manage my AWS Builder ID": "내 AWS 빌더 ID 관리",
	"Your email address that you use to sign in and access different AWS experiences.": "로그인하고 다양한 AWS 경험에 액세스하는 데 사용하는 이메일 주소입니다.",
	"Email address": "이메일 주소",
	"Email type": "이메일 유형",
	"AWS Builder ID email": "AWS Builder ID 이메일",
	"If you did not receive an email, please check your spam or junk folder.": "이메일을 받지 못한 경우 스팸 또는 정크 폴더를 확인하세요.",
	"No additional emails added.": "추가 이메일이 없습니다.",
	"Please enter a verification code.": "인증 코드를 입력하세요.",
	"Verification code must be at least 6 characters": "인증 코드는 최소 6자 이상이어야 합니다",
	"Federate email": "Federate 이메일",
	"This information will update existing public details that other members in the community will see across <a class='link' href='https://repost.aws' rel='noopener noreferrer' target='_blank' >re:Post</a>, <a class='link' href='https://builder.aws.com' rel='noopener noreferrer' target='_blank' >Builder Center</a>, and comments on <a href='https://aws.amazon.com/blogs/' class='link' rel='noopener noreferrer' target='_blank' >AWS Blogs</a>. Please make sure to follow <a href='https://aws.amazon.com/codeofconduct/' class='link' rel='noopener noreferrer' target='_blank' >code of conduct</a> when saving your community information.": "이 정보를 업데이트하면 <a class='link' href='https://repost.aws' rel='noopener noreferrer' target='_blank' >re:Post</a>, <a class='link' href='https://builder.aws.com' rel='noopener noreferrer' target='_blank' >Builder Center</a> 및 <a href='https://aws.amazon.com/blogs/' class='link' rel='noopener noreferrer' target='_blank' >AWS Blog</a>의 코멘트에서 다른 커뮤니티 구성원에게 보이는 기존의 공개 세부 정보도 업데이트됩니다. 커뮤니티 정보를 저장할 때는 <a href='https://aws.amazon.com/codeofconduct/' class='link' rel='noopener noreferrer' target='_blank' >행동 강령</a>을 준수하시기 바랍니다.",
	"Display country": "보이는 국가",
	"Display state": "보이는 주",
	Headline: "헤드라인",
	"Email marketing preferences": "이메일 마케팅 기본 설정",
	"Select a verified email to manage your email marketing preferences.": "인증된 이메일을 선택하여 이메일 마케팅 기본 설정을 관리하세요.",
	Manage: "엣지 디바이스",
	"Email preferences": "이메일 기본 설정"
};
var koKR = {
	translation: translation
};

export { koKR as default, translation };
